module.exports = __webpack_public_path__ + "img/skrill_select.4b59d53c.png";